const pkg = state => state.pkg
const app = state => state.app
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const menuitems = state => state.menu.items

const componententry = state => {
  return state.menu.items.filter(c => c.meta && c.meta.label === 'Components')[0]
}
const loadedScenario = state => {
  return state.loadedScenario
}

const loggedRole = state => {
  return state.loggedRole
}

const loggedUser = state => {
  return state.loggedUser
}

const loggedUserState = state => {
  return state.loggedUserState
}

const isLogged = state => {
  return state.isLogged
}

const loggedId = state => {
  return state.loggedId
}

const permissionMap = state => {
  return state.permissionMap
}

const clientId = state => {
  return state.clientId
}

const authenticationToken = state => state.authenticationToken

export {
  pkg,
  app,
  device,
  sidebar,
  effect,
  menuitems,
  componententry,
  loadedScenario,
  authenticationToken,
  loggedRole,
  loggedUser,
  loggedUserState,
  isLogged,
  loggedId,
  permissionMap,
  clientId
}



// WEBPACK FOOTER //
// ./client/store/getters.js